type TCreateUnauthorizedHandlerPayload = {
  isAuthenticated: () => boolean;
  reload: () => void;
};

const _statusFrom = (value: unknown): number | null => {
  if (typeof value === 'number') return value;
  if (typeof value !== 'object' || value === null || !('status' in value)) return null;

  return typeof value.status === 'number' ? value.status : null;
};

export const createUnauthorizedHandler = ({
  isAuthenticated,
  reload,
}: TCreateUnauthorizedHandlerPayload): ((value: unknown) => boolean) => {
  let reloadStarted = false;

  return (value: unknown): boolean => {
    if (_statusFrom(value) !== 401 || !isAuthenticated()) return false;

    if (!reloadStarted) {
      reloadStarted = true;
      reload();
    }

    return true;
  };
};

export const handleUnauthorized = createUnauthorizedHandler({
  isAuthenticated: () => window.__server__data?.authenticated === true,
  reload: () => window.location.reload(),
});
